/**
 * cn — 조건부 className 합성 유틸리티
 *
 * clsx/classnames 라이브러리의 경량 대체. 외부 의존성 없이
 * falsy 값(false, null, undefined)을 필터링한 뒤 공백으로 조인한다.
 *
 * @example
 *   cn('btn', isActive && 'btn-active', isDisabled && 'btn-disabled')
 *   // isActive=true, isDisabled=false → 'btn btn-active'
 *
 *   cn('text-sm', variant === 'primary' ? 'text-blue' : 'text-gray')
 *   // variant='primary' → 'text-sm text-blue'
 */
export function cn(...classes: (string | false | null | undefined)[]): string {
  return classes.filter(Boolean).join(' ')
}
